module.exports = __webpack_public_path__ + "static/media/Contact.c872d3d1.jpeg";